import React, { Fragment } from "react";

import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";

import {
  MEDIA_THUMBNAIL_URL,
  PLACEHOLDER_IMG_120x120_ERROR_URL
} from "../../config";

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: "#d7d7d7",
    color: "#095460",
    fontWeight: "bold",
    width: 25,
    height: 25
  }
}));

export default function UserAvatarSmall({ mediaId, letter }) {
  const classes = useStyles();
  return (
    <Fragment>
      {mediaId ? (
        <Avatar
          aria-label="user-image"
          className={classes.avatar}
          alt={""}
          src={`${MEDIA_THUMBNAIL_URL}/${mediaId}?width=120`}
          onError={e => {
            e.target.onerror = null;
            e.target.src = PLACEHOLDER_IMG_120x120_ERROR_URL;
          }}
        />
      ) : (
        <Avatar aria-label="recipe" className={classes.avatar}>
          {letter}
        </Avatar>
      )}
    </Fragment>
  );
}
